import script from "./BuddyListCurrentAudio.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuddyListCurrentAudio.vue?vue&type=script&setup=true&lang=ts"

import "./BuddyListCurrentAudio.vue?vue&type=style&index=0&id=07e3efea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e3efea"]])

export default __exports__